import {
  ArrowRight,
  Award,
  Axe,
  Calendar,
  Car,
  ChevronDown,
  ChevronRight,
  CircleCheck,
  Clock,
  Compass,
  Eye,
  FileText,
  Hammer,
  List,
  type LucideIcon,
  type LucideProps,
  Mail,
  MapPin,
  Menu,
  MessageCircle,
  MessagesSquare,
  Mountain,
  Pencil,
  Phone,
  Plus,
  Recycle,
  Ruler,
  ScanEye,
  Scissors,
  ShieldCheck,
  Star,
  TreeDeciduous,
  Trees,
  TriangleAlert,
  Truck,
  Wrench,
  X,
} from 'lucide-react';

const iconMap = {
  ArrowRight,
  Award,
  Axe,
  Calendar,
  Car,
  ChevronDown,
  ChevronRight,
  CircleCheck,
  Clock,
  Compass,
  Eye,
  FileText,
  Hammer,
  List,
  Mail,
  MapPin,
  Menu,
  MessageCircle,
  MessagesSquare,
  Mountain,
  Pencil,
  Phone,
  Plus,
  Recycle,
  Ruler,
  ScanEye,
  Scissors,
  ShieldCheck,
  Star,
  TreeDeciduous,
  Trees,
  TriangleAlert,
  Truck,
  Wrench,
  X,
} as const satisfies Record<string, LucideIcon>;

type IconName = keyof typeof iconMap;

type IconProps = LucideProps & {
  name: IconName;
};

export function Icon({ name, ...props }: IconProps): React.ReactNode {
  const LucideIconComponent = iconMap[name];
  return <LucideIconComponent aria-hidden="true" {...props} />;
}
